import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './shared';
import { mcpSessionGuard } from './features/mcp/mcp-session.guard';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'pages/dashboard' },
  { path: 'agent-console', pathMatch: 'full', redirectTo: 'pages/agent-console' },
  {
    path: 'mcp/connect',
    loadComponent: () =>
      import('./features/mcp/mcp-connect.component').then(m => m.McpConnectComponent),
    canActivate: [mcpSessionGuard],
  },
  {
    path: 'mcp/authorize',
    loadComponent: () =>
      import('./features/mcp/mcp-authorize.component').then(m => m.McpAuthorizeComponent),
    canActivate: [mcpSessionGuard],
  },
  {
    path: 'mcp/connections',
    loadComponent: () =>
      import('./features/mcp/mcp-connections.component').then(m => m.McpConnectionsComponent),
    canActivate: [mcpSessionGuard],
  },
  {
    path: 'pages',
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule),
    // canActivate: [OutGuard],
  },
  {
    path: 'forgot-password',
    loadChildren: () =>
      import('./pages/forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule),
  },
  {
    path: 'reset-password',
    loadChildren: () =>
      import('./pages/reset-password/reset-password.module').then(m => m.ResetPasswordModule),
  },
  {
    path: 'roles',
    loadChildren: () => import('./pages/roles/roles.module').then(m => m.RolesModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'users',
    loadChildren: () => import('./pages/users/users.module').then(m => m.UsersModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'sign-up',
    loadChildren: () => import('./pages/sign-up/sign-up.module').then(m => m.SignUpModule),
  },
  {
    path: 'signup',
    loadChildren: () => import('./pages/sign-up/sign-up.module').then(m => m.SignUpModule),
  },
  {
    path: 'contacts',
    loadChildren: () => import('./pages/contacts/contacts.module').then(m => m.ContactsModule),
  },
];

// `bindToComponentInputs`: the native agents-engine feature (features/agents-engine) reads its route parameters
// through `input()` on the routed components (slug, id, versionNo, step, drawer, conversation, prompt, mode...).
// The option is global, so every routed component of apps/web was audited (2026-10-15) for @Input()/input()/model()
// names that a route parameter, a query parameter or a route `data` key could bind by accident:
// - Routed components (`component:` / `loadComponent:` in app-routing, pages-routing and the lazy *-routing.module.ts
//   and *.routes.ts files): 36. Only two declare inputs: CallQualityComponent (`metadata`, `embedded`) and
//   DynamicViewComponent (`viewId`). Inputs of non-routed (child) components are never bound by the router.
// - No route declares `data`; the only route parameter in apps/web is `:id`; the query parameters Sirius writes are
//   returnUrl, tab, section, mode, path, email, documentType, ecfDocumentId, issueDateFrom and issueDateTo.
// - Parameter names of the agents-engine feature: id, slug, tab, step, section, mode, returnUrl, path, page, size, q,
//   drawer, conversation, prompt, versionNo, v, window.
// No input name matches any of those names, so nothing was renamed or scoped. Before giving a routed component an
// input named like a parameter, repeat the audit (grep `@Input(`, `input(` and `model(` in the routed components).
@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, bindToComponentInputs: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
